var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPopupX = function SvgIconPopupX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.348 3.231A.79.79 0 1 0 3.23 4.348L6.884 8l-3.651 3.651a.79.79 0 1 0 1.116 1.117l3.652-3.652 3.651 3.652a.79.79 0 1 0 1.117-1.117L9.117 8.001l3.653-3.653a.79.79 0 1 0-1.116-1.117L8 6.884 4.348 3.231Z",
    fill: "#fff"
  })));
};
export default SvgIconPopupX;